type UserAction = {
  type: "SET_USER";
  payload: {
    id: string;
    name: string;
    username: string;
    email: string;
  };
};

type UserState = {
  id: string;
  name: string;
  username: string;
  email: string;
} | null;

const user = (state: UserState = null, action: UserAction): UserState => {
  switch (action.type) {
    case "SET_USER": {
      const { id, name, username, email } = action.payload;
      return {
        ...state,
        id,
        name,
        username,
        email
      };
    }
    default:
      return state;
  }
};

export default user;
